<template>
    <b-col sm="12" lg="12" v-if="model" :key="this.model.general.uuid">
        <protokol-floating-settings v-if="$isPlatformEnv('dev')">
            <b-button variant="dark" :to="listLink" :append="true" v-if="$can('see ' + this.model.general.name)">{{ $t('list') }}</b-button>
        </protokol-floating-settings>
        <b-card>
            <b-row>
                <b-col sm="12" lg="4">
                    <b-form-group
                        :label="this.$t('liveVersion')"
                        label-for="version"
                        :label-cols="12"
                        :horizontal="true">
                        <b-form-input :value="model.general.public_version || 'unknown'" disabled />
                    </b-form-group>
                </b-col>
                <b-col sm="12" :lg="(model.general.public_version !== this.currentVersion) ? 4 : 3">
                    <b-row>
                        <b-col sm="12">
                            <b-form-group
                                :label="this.$t('devVersion')"
                                label-for="version"
                                :label-cols="12"
                                :horizontal="true">

                                    <b-input-group>
                                        <b-form-input :value="model.general.dev_version" disabled />

                                        <b-input-group-append v-if="model.general.public_version != model.general.dev_version">
                                            <b-button variant="warning" @click="deployToLive(model.general.dev_version)" style="width: 100%" class="mb-3">Deploy to live</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" lg="4">
                    <b-form-group
                        :label="this.$t('previewVersion')"
                        label-for="version"
                        :label-cols="12"
                        :label-cols-sm="12"
                        :horizontal="true">
                            <b-form-select :options="componentVersions" v-model="currentVersion" @change="previewVersion"/>
                        </b-form-group>
                </b-col>
            </b-row>

            <b-spinner v-if="this.model === null" />

          <b-card no-body  v-if="this.model !== null">
          <b-tabs card pills nav-wrapper-class="col-12" v-model="tabIndex" small>
            <b-tab @click="tabChange('general')">
              <template slot="title">
                <i class="icon-screen-desktop"></i> {{ $t('general') }}
              </template>

              <b-form-group
                    :description="this.$t('uniqueId')"
                    :label="this.$t('uuid')"
                    label-for="basicName"
                    :label-cols="2"
                    :horizontal="true">
                    <b-form-input id="uuid" type="text" :value="model.general.uuid" disabled></b-form-input>
                </b-form-group>
                <b-form-group
                    label-for="basicName"
                    :label-cols="2"
                    :horizontal="true">
                     <choose-icon :item="model.general" v-model="model.general.icon"/>
                </b-form-group>
              <b-form-group
                    :description="this.$t('registeredComponent')"
                    :label="this.$t('name')"
                    label-for="basicName"
                    :label-cols="2"
                    :horizontal="true">
                    <b-form-input id="component_name" type="text" :value="model.general.name" disabled></b-form-input>
                </b-form-group>

                <b-form-group
                    :label="this.$t('label')"
                    label-for="label"
                    :label-cols="2"
                    :disabled="!canRemove"
                    :horizontal="true">
                        <Labeli18n v-model="model.general.label" />
                </b-form-group>

                <b-form-group
                    :label="this.$t('tag')"
                    label-for="tag"
                    :label-cols="2"
                    :description="this.$t('tagDescription')"
                    :disabled="!canRemove"
                    :horizontal="true">
                        <v-select v-model="model.general.tag" noDrop taggable :disabled="!canRemove"/>
                </b-form-group>

                <b-form-group
                    :label="this.$t('scope')"
                    label-for="scope"
                    :label-cols="2"
                    :description="this.$t('scopeDescription')"
                    :disabled="!canRemove"
                    :horizontal="true">
                        <v-select v-model="model.general.scope" :disabled="!canRemove" noDrop taggable/>
                </b-form-group>

                <b-form-group
                    :description="this.$t('sortSidebar')"
                    :label="this.$t('sort')"
                    label-for="order"
                    :label-cols="2"
                    :horizontal="true">
                    <b-form-input id="sort" type="number" v-model.number="model.general.sort"></b-form-input>
                </b-form-group>
                 <b-form-group
                    :description="this.$t('publishComponent')"
                    :label="this.$t('public')"
                    label-for="is_public"
                    :label-cols="2"
                    :horizontal="true">
                    <c-switch class="mx-1" color="success" variant="pill" v-model="model.general.is_public" :disabled="!canBePublic"/>
                </b-form-group>
                <b-form-group
                    :description="canBeActive ? '' : 'Component can\'t be active without proper fields setup'"
                    :label="this.$t('active')"
                    label-for="is_active"
                    :label-cols="2"
                    :horizontal="true">
                    <c-switch class="mx-1" color="success" variant="pill" v-model="model.general.is_active" :disabled="!canBeActive"/>
                </b-form-group>
                 <b-form-group
                    :description="this.$t('assignComponent')"
                    :label="this.$t('workspaces')"
                    label-for="workspaces"
                    :label-cols="2"
                    :horizontal="true">
                    <v-select name="workspace" label="text" v-model="model.workspaces" multiple v-if="workspaces" :options="workspaces" :reduce="w => w.value" />
                </b-form-group>
                <b-form-group
                    :label="this.$t('createdAt')"
                    label-for="created_at"
                    :label-cols="2"
                    :horizontal="true">
                    <b-form-input id="created_at" type="text" :value="$toUserTimeZone(model.general.CreatedAt)" disabled></b-form-input>
                </b-form-group>
                <b-form-group
                    :label="this.$t('updatedAt')"
                    label-for="updated_at"
                    :label-cols="2"
                    :horizontal="true">
                    <b-form-input id="updated_at" type="text" :value="$toUserTimeZone(model.general.UpdatedAt)" disabled></b-form-input>
                </b-form-group>

                 <b-form-group
                    v-if="canRemove"
                    :description="this.$t('createComponent')"
                    :label-cols="2"
                    :horizontal="true">
                    <div class="form-action">
                        <b-button v-on:click="clone.modal = true">{{ $t('clone') }}</b-button>
                    </div>

                    <b-modal title="Clone component" v-model="clone.modal" @close="clone.modal = false" @ok="cloneComponent" ok-title="Clone">
                        <b-form-group
                            label-for="component_name"
                            :horizontal="true">
                            <b-form-input id="component_name" type="text" v-model="clone.name" placeholder="New component name"></b-form-input>
                        </b-form-group>
                    </b-modal>
                </b-form-group>

                <b-form-group
                    v-if="canRemove"
                    :description="this.$t('copyComponent')"
                    :label-cols="2"
                    :horizontal="true">
                    <div class="form-action">
                        <b-button v-on:click="copySchema()">{{ $t('copySchema') }}</b-button>
                    </div>
                </b-form-group>

                <b-form-group
                    :description="this.$t('createNewVersion')"
                    :label-cols="2"
                    :horizontal="true">
                    <div class="form-action">
                        <b-button v-on:click="initFork" class="mr-2">{{ $t('fork') }}</b-button>
                        <b-button v-on:click="forkSchemaModal = true" v-if="canRemove">{{ $t('forkFromSchema') }}</b-button>
                    </div>

                    <b-modal title="Fork version" v-model="forkVersionModal" @close="forkVersionModal = false" @ok="forkVersion" ok-title="Fork">
                        <b-form-group
                            :label="this.$t('forkFrom')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-input id="forkName" type="text" v-model="fork.from" disabled></b-form-input>
                        </b-form-group>

                        <b-form-group
                            :label="this.$t('version')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-input id="forkName" type="text" v-model="fork.to"></b-form-input>
                        </b-form-group>
                    </b-modal>

                    <b-modal title="Fork from schema" v-model="forkSchemaModal" @close="forkSchemaModal = false" @ok="forkSchemaAction" ok-title="Fork">
                        <b-form-group
                            :label="this.$t('version')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-input id="forkName" type="text" v-model="forkSchema.version"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            :label="this.$t('schema')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-textarea v-model="forkSchema.data" />
                        </b-form-group>
                    </b-modal>
                </b-form-group>

                <b-form-group
                    :description="this.$t('deploySettings')"
                    :label-cols="2"
                    :horizontal="true">
                    <div class="form-action">
                        <b-button variant="success" v-on:click="deployVersionModal = true">{{ $t('deploy') }}</b-button>
                    </div>

                    <b-modal title="Deploy version" v-model="deployVersionModal" @close="deployVersionModal = false" @ok="deployVersion" ok-title="Deploy">
                        <b-form-group
                            :label="this.$t('deployTo')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-select v-model="deployEnv" :options="['dev', 'live']"></b-form-select>
                        </b-form-group>

                        <b-form-group
                            :label="this.$t('version')"
                            label-for="version"
                            :label-cols="2"
                            :horizontal="true">
                            <b-form-input id="forkName" type="text" :value="this.currentVersion" disabled></b-form-input>
                        </b-form-group>
                    </b-modal>
                </b-form-group>

                <b-form-group
                    :label-cols="2"
                    :horizontal="true">
                <div class="form-action">
                    <b-button variant="danger" v-on:click="removeCurrentVersion" :disabled="model.general.public_version == currentVersion || model.general.dev_version == currentVersion"> {{ $t('removeVersion') }} </b-button>
                </div>
                </b-form-group>

                <b-form-group
                    :description="canRemove ? this.$t('removeComponent') : this.$t('cantRemoveComponent')"
                    :label-cols="2"
                    :horizontal="true">
                <div class="form-action">
                    <b-button variant="danger" v-on:click="removeComponent" :disabled="!canRemove">{{ $t('remove') }}</b-button>
                </div>
                </b-form-group>

            </b-tab>
            <b-tab href="#appearance" @click="tabChange('appearance')">
              <template slot="title">
                <i class="icon-layers"></i> {{ $t('appearance') }}
              </template>

              <Appearance v-model="model.settings.appearance" :component="model" />

            </b-tab>
            <b-tab href="#list" @click="tabChange('list')">
              <template slot="title">
                <i class="icon-menu"></i> List
              </template>
                <b-form-group
                    :description="this.$t('quickActionOnRow')"
                    :label="this.$t('quickActions')"
                    :label-cols="2"
                    :horizontal="true">
                    <c-switch class="mx-1" color="success" variant="pill" v-model="model.settings.list.quick_actions"/>
                </b-form-group>

                <Presets v-model="model.settings.presets" />
            </b-tab>
            <b-tab href="#fields" @click="tabChange('fields')" :disabled="!canBeUpdated()">
              <template slot="title">
                <i class="icon-pencil"></i> {{ $t('fields') }}
              </template>
              <Fields v-model="model.settings.fields" :component="model" :config="{custom:model.general.is_custom,dependencyProtected:!canRemove}"/>
            </b-tab>

            <b-tab href="#model" @click="tabChange('model')">
              <template slot="title">
                <i class="icon-vector"></i> {{ $t('model') }}
              </template>
                
                <b-form-group
                    :description="this.$t('cleanupModelsAfterDescription')"
                    :label="this.$t('cleanup')"
                    :label-cols="2"
                    :horizontal="true">
                    <b-input-group>
                        <b-form-input type="number" v-model.number="modelCleanupAfter" />
                        <template #append>
                            <b-input-group-text> {{ $t('days') }} </b-input-group-text>
                        </template>
                    </b-input-group>
                </b-form-group>
            </b-tab>
            <b-tab href="#workflow" @click="tabChange('workflow')" lazy>
              <template slot="title">
                <i class="icon-share"></i> {{ $t('workflow.title') }}
              </template>
                    <Events v-model="model.settings.model.events" :uuid="model.general.uuid"/>
            </b-tab>
            <b-tab href="#functions" @click="tabChange('functions')">
              <template slot="title">
                <b-icon icon="braces" /> {{ $t('functions.title') }}
              </template>
                    <Functions v-model="model.settings.functions" :id="ref" :config="model.settings.config" />
            </b-tab>
            <b-tab href="#config" @click="tabChange('config')">
              <template slot="title">
                <b-icon icon="braces" /> {{ $t('config.title') }}
              </template>
                    <CodeEditor v-model="componentConfig" :withButton="false" />
            </b-tab>
            <!-- <b-tab href="#routes" @click="tabChange('routes')" :disabled="!canBeUpdated()">
              <template slot="title">
                <i class="fa fa-random"></i> {{ $t('routes') }}
              </template>
              <Routes v-model="model.settings.routes" />
            </b-tab> -->

            <RenderEvent
            event="settings"
            v-model="model.settings.integrations"
            :disabled="!canBeUpdated()"
            :currentVersion="this.currentVersion"
            :settings="model"
            />
          </b-tabs>
          </b-card>
            <div class="form-actions pull-right">
                <b-button type="submit" variant="success" v-on:click="saveSettings" v-if="settingsChanged" class="m-2" :disabled="saving"> <b-spinner v-if="saving" small /> <span v-else>{{ $t('saveChanges') }}</span> </b-button>
                <b-button  variant="primary" v-on:click="restoreSettings" v-if="settingsChanged" class="m-2">{{ $t('restoreChanges') }}</b-button>
            </div>
        </b-card>
      </b-col>
      <b-spinner v-else></b-spinner>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Fields from './Settings/FieldsV2'
import ListFields from './Settings/ListFields'
import Presets from './Settings/Presets'
import Appearance from './Settings/Appearance'
import Actions from './Settings/Actions'
import Events from './Settings/Events'
import Routes from './Settings/Routes'
import RenderEvent from '../integrations/RenderEvent'
import _ from 'lodash'
import Labeli18n from '../form/Texti18n.vue'
import VSelect from 'vue-select'
import ChooseIcon from '../elements/ChooseIcon'
import Functions from './Settings/Functions'
import CodeEditor from '../form/Editor/Code'

export default {
    components: {
        cSwitch,
        Fields,
        ListFields,
        Appearance,
        Actions,
        Events,
        Routes,
        RenderEvent,
        Presets,
        Labeli18n,
        VSelect,
        ChooseIcon,
        Functions,
        CodeEditor,
    },
    props: {
        id: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            model: null,
            modelCopy: null,
            ready: false,
            saving: false,
            tabIndex: 0,
            tabHash: ["#general", "#appearance", "#list", "#fields", "#model", "#workflow", "#functions", "#config"],
            forkVersionModal: false,
            deployVersionModal: false,
            deployEnv: 'dev',
            currentVersion: this.componentDefaultVersion,
            deploy: {
                env: '',
                version: ''
            },
            fork: {
                from: '',
                to: ''
            },
            forkSchemaModal: false,
            forkSchema: {
                data: '',
                version: ''
            },
            clone: {
                modal: false,
                name: ''
            },
            forceSettingsChanged: false,
            spaces: []
        }
    },
    computed: {
        ref() {
            return this.id || this.$route.params.ref
        },

        fields() {
            return this.model.settings.fields || []
        },

        settingsChanged() {
            if (this.forceSettingsChanged) return true;

            if (!this.model || !this.modelCopy) {
                return false
            }

            return !_.isEqual(this.modelCopy, this.model)
        },

        canBeActive() {
            return this.model.settings.fields !== null || this.fields.length > 0
        },

        canBePublic() {
            return this.canBeActive && this.model.general.is_active
        },

        canRemove() {
            if (this.model.general.dependencies === null) return true
            
            return this.model.general.dependencies.length == 1 && this.model.general.dependencies[0] == "platform"
        },

        componentConfig: {
            get() {
                return JSON.stringify(this.model.settings.config || '{}', null, 4)
            },

            set(val) {
                this.model.settings.config = JSON.parse(val)
            }
        },

        modelCleanupAfter: {
            get() {
                return this.model.settings.model.cleanup_after
            },

            set(val) {
                this.model.settings.model.cleanup_after = val || null
            }
        },

        componentVersions: {
            get() {
                if (this.model === null) {
                    return []
                }

                if (this.model.general === undefined) {
                    return []
                }

                return this.model.general.versions.map(v => {
                    return {
                        text: v.version,
                        value: v.version
                    }
                }).reverse()
            },

            set(val) {
                this.model.general.versions = val
            }
        },

        workspaces() {
            return this.$store.getters.getCurrentProject.workspaces.map(w => {
                return {
                    text: w.name,
                    value: w.uuid
                }
            })
        },

        componentDefaultVersion() {
            if (this.$isPlatformEnv('dev')) {
                return this.model.general.dev_version
            }

            if (this.$isPlatformEnv('live')) {
                return this.model.general.public_version || this.model.general.dev_version
            }

            return null
        },

        listLink() {
            return this.$route.path.replace("/settings", "")
        }
    },
    watch: {
        model: {
            handler() {
                let { tag, scope } = this.model.general

                if (scope) {
                    this.model.general.scope = scope.replaceAll(" ", "_").replaceAll("::","_").replaceAll(/[^a-zA-Z0-9_-]/g, '')
                }

                this.model.general.tag = tag.replaceAll(" ", "_").replaceAll(/[^a-zA-Z0-9_-]/g, '')
                
            },
            deep: true
        },

        watch:{
            $route (){
                 let m = this.model
                if (m === undefined) {
                    this.$store.dispatch("fetchComponentsSettings", this.ref).then((data) => {

                        this.model = _.cloneDeep(data)
                        this.modelCopy = _.cloneDeep(this.model)

                        this.$store.commit("SET_CURRENT_COMPONENT", data)
                        this.$store.commit("SET_COMPONENTS_SETTINGS", data)
                    })

                    return
                }

                this.model = _.cloneDeep(m)
                this.modelCopy = _.cloneDeep(this.model)

                this.$store.commit("SET_CURRENT_COMPONENT", m)

                this.currentVersion = this.componentDefaultVersion;

                let hash = window.location.hash
                this.tabIndex = this.tabHash.indexOf(hash)
            }
        }
    },
    methods: {
        saveSettings() {
            this.saving = true;
            let uuid = this.ref

            let version = this.currentVersion
            if (version === undefined) {
                version = this.componentDefaultVersion
            }

            this.$http.post("/v3/system/component/settings/" + uuid + "/" + version, this.model).then((resp) => {
                if (resp == null) {
                    throw new Error("unexpected error")
                }

                this.$bvToast.toast(this.$t('success'), {
                    variant: 'success',
                })

                this.modelCopy = _.cloneDeep(this.model)
                this.model = resp.data

                let ref = this.model.general.name
                if (this.model.general.scope) {
                    ref = this.model.general.scope + "/" + ref
                }

                this.$router.push(`/admin/component/${ref}/settings`)

                this.$store.commit("SET_COMPONENTS_SETTINGS", this.model)
                this.$store.commit("UPDATE_COMPONENTS_MENU_ICON", {uuid: uuid, icon: this.model.settings.appearance.icon})
                this.$store.commit("UPDATE_COMPONENTS_MENU_ACTIVE", {uuid: uuid, is_active: this.model.general.is_active})
                this.$store.commit("UPDATE_COMPONENTS_MENU_SORT", {uuid: uuid, sort: this.model.general.sort})
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)
                    return
                }

                this.$bvModal.msgBoxOk(error.message)
            }).finally(() => {
                this.saving = false
            })
        },

        copySchema() {
            navigator.clipboard.writeText(JSON.stringify(this.model.settings));
        },

        restoreSettings() {
            this.model = _.cloneDeep(this.modelCopy)
        },

        tabChange(e) {
            window.location.hash = e
        },

        removeComponent() {
            let uuid = this.ref

            this.$bvModal.msgBoxConfirm(this.$t('thisActionRemove')).then(resp => {
                if (resp) {
                    this.$http.delete("/v3/system/component/" + uuid).then(() => {
                        this.$store.commit("REMOVE_COMPONENT", uuid)
                        this.$router.push({path: "/admin/dashboard"})
                    }).catch(err => {
                        if (err.response.status == 500) {
                            this.$serverErrorModal(err)
                            return
                        }

                        this.$bvModal.msgBoxOk(err.response.data.message)
                    })
                }
            })
        },

        cloneComponent() {
            this.$http.post("/v3/system/component/clone", {name: this.clone.name, ref: this.ref}).then((resp) => {
                this.$router.push({path: "/admin/component/" + resp.data.uuid + "/settings"})
            }).catch(err => {
                if (err.response.status == 500) {
                    this.$serverErrorModal(err)
                    return
                }

                this.$bvModal.msgBoxOk(err.response.data.message)
            })
        },

        previewVersion() {
            let uuid = this.ref
            this.model = null
            this.$http.get("/v3/system/component/settings/" + uuid + "/" + this.currentVersion).then((resp) => {
                this.model = resp.data
                this.modelCopy = _.cloneDeep(this.model)
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        initFork() {
            this.forkVersionModal = true;
            this.fork.from = this.currentVersion;
        },

        forkSchemaAction() {
            this.$http.post("/v3/system/component/version/fork/schema", {
                schema: this.forkSchema.data,
                version: this.forkSchema.version,
                ref: this.ref
            }).then(() => {
                this.currentVersion = this.forkSchema.version
                this.previewVersion()
                this.componentVersions.push({
                    text: this.forkSchema.version,
                    value: this.forkSchema.version
                })
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        forkVersion() {
            let found = this.componentVersions.find(v => v.value == this.fork.to)
            if (found) {
                this.$bvToast.toast(this.$t('cantForkVersionExist'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })

                return
            }

            this.$http.post("/v3/system/component/version/fork", {
                name: this.fork.to,
                from: this.fork.from,
                ref: this.ref
            }).then(() => {
                this.currentVersion = this.fork.to
                this.previewVersion()
                this.componentVersions.push({
                    text: this.currentVersion,
                    value: this.currentVersion
                })
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        removeCurrentVersion() {
            this.$http.post("/v3/system/component/version/remove", {
                version: this.currentVersion,
                ref: this.ref
            }).then(() => {
                this.componentVersions = this.componentVersions.filter(v => {
                    return v.value !== this.currentVersion
                })

                this.currentVersion = this.componentVersions[0].value
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        deployVersion() {
            var popup = this.$loadingPopup("Deploying version " + this.currentVersion + " to " + this.deployEnv + " env.");

            this.$http.post("/v3/system/component/version/publish", {
                version: this.currentVersion,
                env: this.deployEnv,
                ref: this.ref
            }).then(() => {
                if (this.deployEnv == 'dev') {
                    this.model.general.dev_version = this.currentVersion

                    this.modelCopy = _.cloneDeep(this.model)

                    this.$store.commit("SET_COMPONENTS_SETTINGS", this.model)
                    this.$store.commit("UPDATE_COMPONENTS_MENU_ICON", {uuid: this.model.general.uuid, icon: this.model.settings.appearance.icon})
                    this.$store.commit("UPDATE_COMPONENTS_MENU_ACTIVE", {uuid: this.model.general.uuid, is_active: this.model.general.is_active})
                    this.$store.commit("UPDATE_COMPONENTS_MENU_SORT", {uuid: this.model.general.uuid, sort: this.model.general.sort})

                    this.$bvModal.hide('loadingPopup');
                }

                if (this.deployEnv == 'live') {
                   this.model.general.public_version = this.currentVersion
                }

            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)
                }

            }).finally(() => {
                popup.hide()
            })
        },

        deployToLive(version) {
            this.$bvModal.msgBoxConfirm(this.$t('areYouSureDeployVersion') + ' ' + this.currentVersion + ' ' + this.$t('asLive') + ' ' + this.model.general.public_version + ".", {
                okTitle: "Proceed",
                okVariant: "success"
            }).then(resp => {
                let popup = this.$loadingPopup(this.$t('deployVersion') + ' ' + version + ' ' + this.$t('toLiveEnv'))
                if (resp) {
                    this.$http.post("/v3/system/component/version/publish", {
                        version: version,
                        env: 'live',
                        ref: this.ref
                    }).then(() => {
                        this.$bvModal.msgBoxOk(this.$t('version') + ' ' + version + ' ' + this.$t('deployedAsLive'))
                        this.model.general.public_version = version
                        this.modelCopy = _.cloneDeep(this.model)
                    }).catch(error => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                return
                            }
                        }

                        this.$bvModal.msgBoxOk(error.response.data.message)
                    }).finally(() => {
                        popup.hide()
                    })
                }
            })

        },

         deployToDev(version) {
            this.$http.post("/v3/system/component/version/publish", {
                version: version,
                env: 'dev',
                ref: this.ref
            }).then(() => {
                this.version = this.form.to
                this.previewVersion()
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        canBeUpdated() {
            return this.currentVersion !== this.model.general.public_version
        },

        workspaceChange() {
            this.forceSettingsChanged = true;
        }

    },
    beforeRouteLeave(to, from, next) {
        if (this.settingsChanged) {
            this.$bvModal.msgBoxConfirm(this.$t('unsavedSettings')).then(resp => {
                if (resp) {
                    if (!this.saveSettings()) {
                        return
                    }
                } else {
                    this.restoreSettings()
                }

                next()
            })
        } else {
            next()
        }
    },

    mounted() {
        this.$store.dispatch("fetchComponentsSettings", this.ref).then((data) => {
            this.model = Object.assign({}, data)
            this.modelCopy = Object.assign({}, _.cloneDeep(this.model))

            console.log("Settings mounted", this.model.general)

            this.$store.commit("SET_CURRENT_COMPONENT", data)
            this.$store.commit("SET_COMPONENTS_SETTINGS", data)

            this.currentVersion = this.componentDefaultVersion

            let hash = window.location.hash
            this.tabIndex = this.tabHash.indexOf(hash)
        })

    }
}
</script>
